const MAX_TEAM_NAME_LENGTH = 30;

export { MAX_TEAM_NAME_LENGTH };
